/**
 * Handles the fancy scrolling ERA log on the home page
 */

const position = () => {

	const logosContainer = document.querySelector('.cmylogos')

	if (!logosContainer) return

	const logos = logosContainer.querySelectorAll('.cmylogos__logo')
	const midpoint = window.innerHeight / 2

	logos.forEach(el => {
		const float = el.dataset.float / 5 || 0
		const rect = el.getBoundingClientRect()
		const height = rect.height
		const top = rect.top
		const distanceFromCenter = top + height / 2 - midpoint
		const offset = distanceFromCenter * float
		el.style.setProperty('--offset', `${offset}px`)
	})

}

const cmylogo = () => {
	document.addEventListener('scroll', position)
	position()
}

export default cmylogo
